import * as React from "react";
import { styled } from "styled-components";

const SpinnerWrap = styled.div`
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;

  & div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 64px;
    height: 64px;
    margin: 8px;
    border: 8px solid ${(props) => props.theme.colours.primary};
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: ${(props) => props.theme.colours.primary} transparent transparent transparent;
  }
  & div:nth-child(1) {
    animation-delay: -0.45s;
  }
  & div:nth-child(2) {
    animation-delay: -0.3s;
  }
  & div:nth-child(3) {
    animation-delay: -0.15s;
  }
  @keyframes lds-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const Spinner: React.FC = () => (
  <SpinnerWrap>
    <div />
    <div />
    <div />
    <div />
  </SpinnerWrap>
);

const Centered = styled.div`
  display: flex;
  align-content: center;
  justify-content: center;
  flex: 1;
  flex-direction: column;
  align-items: center;
  font-family:
    "Mulish",
    -apple-system,
    BlinkMacSystemFont,
    sans-serif;
  text-align: center;
  color: #444444;
  font-weight: 500;
  font-size: 16px;
`;

export const Loading: React.FC = () => {
  return (
    <Centered>
      <Spinner />
      <div>Loading</div>
    </Centered>
  );
};
